import React, { useEffect, useState } from 'react'
import ColoredBox from 'components/ColoredBox'
import { useAppDispatch, useAppSelector } from 'commons/store/hooks'
import {
    fetchAdverseEvents,
    fetchAdverseEventsFields,
    selectAdverseEvents,
    selectEcrf
} from 'features/ecrf/redux/ecrfSlice'
import TableForm from 'components/Table/TableForm'
import ModalForm from "components/Form/Modal/ModalForm";
import ElementTable from "core/helpers/ElementTable";
import { enqueueSnackbar } from 'notistack'
import { useSearchParams } from "react-router-dom";
import { FilterPanel } from "./FilterPanel";
import { useTranslation } from "react-i18next";
import { fetchMedicalCenters } from "../../../medicalCenters/redux/medicalCentersSlice";
import { MIME_TYPE, parsePage } from "utils/dataAccess";

const DashboardAdverseEvents = () => {
    const dispatch = useAppDispatch();
    const adverseEvents = useAppSelector(selectAdverseEvents);
    const ecrf = useAppSelector(selectEcrf);
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const [page, setPage] = useState(1)
    const [columns, setColumns] = useState<any[]>([]);
    const [isLoading, setLoading] = useState(true);

    const [data, setData] = useState<any>({
        itemsPerPage: 0,
        totalItems: 0,
        _embedded: { item: [] }
    });

    const loadMedicalCenters = async () => {
        await dispatch(fetchMedicalCenters({}))
    }

    /**
     * This function is used to fetch ecrves list
     */
    const fetchData = async (initial?: boolean) => {
        setLoading(true);

        try {
            let fields: any = [];
            if (initial) {
                fields = await dispatch(fetchAdverseEventsFields()).unwrap();
                fields && setColumns(ElementTable.createColumns(fields.slice(0, 4)) || []);
            }

            const config = {
                headers: {
                  'Content-Type': MIME_TYPE,
                    Accept: MIME_TYPE,
                },
                params: {
                    pagination: true,
                    page,
                    itemsPerPage: 30,
                    ...Object.fromEntries(searchParams)
                },
            };

            const response = await dispatch(fetchAdverseEvents(config)).unwrap();
            setData(response);
        } catch (error: any) {
            enqueueSnackbar(error?.detail || error?.response?.data, { variant: 'error' });
        }

        setLoading(false);
    };

    useEffect(() => {
        loadMedicalCenters().then()
        fetchData(true).then()
    }, [dispatch, page, ecrf]);

    useEffect(() => {
        !isLoading && fetchData().then()
    }, [searchParams]);

    return (
        <ColoredBox pt={0} px={5} maxWidth="100%" ml="auto" mr="auto">
            <FilterPanel/>
            <TableForm
                collections={!isLoading && { rows: adverseEvents?.['member'] ||  adverseEvents || [] }}
                pagination={{
                    current: page,
                    pageSize:
                      adverseEvents?.itemsPerPage ||
                      Math.ceil(adverseEvents?.totalItems / parsePage(adverseEvents?.['view']?.["last"] ?? 0)) ||
                      0,
                    total: adverseEvents?.totalItems
                }}
                page={page}
                setPage={setPage}
                columns={columns}
                tableName={t('adverse-events')}
                elementName={adverseEvents && adverseEvents.length ? adverseEvents[0].elementName : ''}
                isLoading={isLoading}
                ecrfOption={true}
            />
            <ModalForm/>
        </ColoredBox>
    )
}

export default DashboardAdverseEvents
